export const CONFIG = {
  mailchimpUrl:
    'https://serenawilliams.us18.list-manage.com/subscribe/post-json?u=f6c8de6343a592daf21a1656d&id=3555e95248&c=',
};



// WEBPACK FOOTER //
// ./src/util/config.js